module.exports = __webpack_public_path__ + "../PRE/appsettings.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=../PRE/[name].[ext]!./configs/appSettings/PRE/appsettings.js
// module id = 757
// module chunks = 1